const getFirstGoalPerCycle = (data) => {
    const result = [];
    const seenCycles = new Set();
  
    data?.forEach(item => {
      if (!seenCycles.has(item?.cycle_id)) {
        result.push(item);
        seenCycles.add(item?.cycle_id);
      }
    });
  
    return result;
  };

export default getFirstGoalPerCycle